import { Divider, Typography } from '@mui/material';
import {
  INCOME_OR_EXPENSE_LIST,
  LP_INVESTMENT_LIST,
  LP_REALISATION_LIST,
} from 'adminConstants/routes';
import Page from 'components/new/Page';
import TransactionAllocator from 'components/TransactionAllocator';
import { useLayoutContext } from 'contexts/LayoutContext';
import { CalendarDay } from 'further-ui/utils';
import { Column } from 'further-ui/components/Layout';
import StaticField from 'further-ui/components/StaticField';
import useTransactionTypeSelectorOptions from 'hooks/form/useTransactionTypeSelectorOptions';
import api from 'lib/trpcClient';
import React from 'react';
import { useParams } from 'react-router-dom';

const ViewGenericReversalPage: React.FC<{ vehicleId: string }> = ({
  vehicleId,
}) => {
  const { actionId, type } = useParams<{ actionId: string; type: string }>();

  const backActionByType: Record<string, string> = {
    investment: LP_INVESTMENT_LIST,
    realisation: LP_REALISATION_LIST,
    'income-or-expense': INCOME_OR_EXPENSE_LIST,
  };
  const { transactionTypeOptions } = useTransactionTypeSelectorOptions();
  const { vehicle } = useLayoutContext();

  const [existingReversal] = api.lpReversal.getReversal.useSuspenseQuery({
    vehicleId,
    actionId: actionId ?? '',
  });

  const reversalLedgerDate = existingReversal
    ? existingReversal.ledgerDate
    : new CalendarDay(new Date());

  const [reversalTransactions] =
    api.lpReversal.getTransactions.useSuspenseQuery({
      vehicleId,
      actionId: actionId ?? '',
      reversalDate: reversalLedgerDate,
    });

  return (
    <Page
      tabTitle="View Reversal"
      spacing="lg"
      heading="View Reversal"
      withHeadingDivider
      goBackAction={backActionByType[type] ?? LP_INVESTMENT_LIST}
    >
      <Column spacing="lg">
        <StaticField label="Reversal date">
          {reversalLedgerDate.toReadable()}
        </StaticField>

        <Divider />

        <Typography variant="h6">Account transactions</Typography>

        {vehicle && (
          <TransactionAllocator
            readOnly
            transactions={reversalTransactions}
            transactionTypeOptions={transactionTypeOptions}
            transactionCurrency={vehicle.baseCurrency}
            vehicle={{
              _id: vehicleId,
              baseCurrency: vehicle.baseCurrency,
              fxDataFeed: vehicle.fxDataFeed,
            }}
            fxRate={null}
          />
        )}
      </Column>
    </Page>
  );
};

export default ViewGenericReversalPage;
